export default __webpack_public_path__ + "media/zurb/img/playground/concept-experiment-cheatsheet-img-4f49c541b36993d7946c765532262da4.png";